<template>
  <div class="catalog-toolbar">
    <!--document selection button-->
    <v-menu offset-y
            style="right: 0;left: 0;"
    >
      <v-btn
        depressed
        color="primary"
        class="catalog-select-doc"
        slot="activator"
        right
      >
        <v-icon dark>mdi-dots-vertical</v-icon>
      </v-btn>
      <v-list style="max-height: 300px;background: white;">
        <template v-for="(emptyDocument, index) in _emptyDocuments">
          <v-list-tile @click="changeCurrentDocument(emptyDocument)" :key="index"
                       v-if="(index === 'rezervirovanie' && _allowBB) || (index === 'schet' && _allowB)">
            <v-list-tile-title>{{ emptyDocument.title }}</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list-tile @click="changeCurrentDocument(doc)" v-for="(doc, index) in _documentsList" :key="index"
                     style="background: white;">
          <v-list-tile-title>{{ doc.title }} № {{ doc.id}} от {{doc.d}}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <!--document view button-->
    <v-btn
      depressed
      color="secondary"
      class="catalog-view-doc"
      right
      @click="showCurrentDocument"
    >
      <template v-if="!_currentDocument.id">
        {{ _currentDocument.title }}
      </template>
      <template v-else>
        {{ _currentDocument.title }} № {{ _currentDocument.id}}
      </template>
      <v-icon right dark v-show="$vuetify.breakpoint.mdAndUp">mdi-open-in-new</v-icon>
    </v-btn>

    <!--document save button-->
    <v-btn
      depressed
      color="accent"
      class="catalog-save-doc"
      right
      @click="saveDocument"
      :loading="_isSaving"
      :disabled="!_currentDocument.records.length"
    >
      <v-icon dark>mdi-content-save</v-icon>
    </v-btn>
    <v-spacer v-show="$vuetify.breakpoint.width > 371"></v-spacer>
    <!--table settings-->
    <v-menu
      v-model="itemsDisplaySettingsMenu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-y
    >
      <v-btn
        slot="activator"
        icon color="primary">
        <v-icon>mdi-settings</v-icon>
      </v-btn>
      <v-card>
        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch v-model="showRezerv" color="red" class="mt-2"></v-switch>
            </v-list-tile-action>
            <v-list-tile-title>Резерв</v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch v-model="showTranzit" color="blue" class="mt-2"></v-switch>
            </v-list-tile-action>
            <v-list-tile-title>Транзит</v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch v-model="showPriemka" color="purple" class="mt-2"></v-switch>
            </v-list-tile-action>
            <v-list-tile-title>Приемка</v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch v-model="showRecommendedOnly" color="accent" class="mt-2"></v-switch>
            </v-list-tile-action>
            <v-list-tile-title>Только рекомендованные ГР</v-list-tile-title>
          </v-list-tile>
        </v-list>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="itemsDisplaySettingsMenu = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <!--search field-->
    <v-text-field
      solo
      flat
      hide-details
      class="catalog-search-field"
      v-model="searchQuery"
      @keyup="searchItems"
      label="Поиск"
      prepend-inner-icon="mdi-magnify"
      clearable
      @click:clear="clearSearch"
    />
    <catalog-document-modal
      @openOptionsDialog="openOptionsDialog"
      @saveDocument="saveDocument"
      ref="catalogDocumentModal"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import CatalogDocumentModal from './CatalogDocumentModal'

export default {
  name: 'CatalogToolbar',
  components: {
    CatalogDocumentModal
  },
  data () {
    return {
      itemsDisplaySettingsMenu: false
    }
  },
  computed: {
    ...mapGetters('catalog', {
      _documentsList: 'documentsList',
      _currentDocument: 'currentDocument',
      _emptyDocuments: 'emptyDocuments',
      _currentFolderId: 'currentFolderId',
      _itemsDisplaySettings: 'itemsDisplaySettings',
      _defaultDocument: 'defaultDocument',
      _getSearchQuery: 'getSearchQuery'
    }),
    ...mapGetters('user', {
      _allowB: 'allowB',
      _allowBB: 'allowBB'
    }),
    ...mapFields('catalog', {
      _isSaving: 'isSaving'
    }),
    searchQuery: {
      set (value) {
        this._setSearchQuery(value)
      },
      get () {
        return this._getSearchQuery
      }
    },
    showRezerv: {
      get () {
        return this._itemsDisplaySettings('showRezerv')
      },
      set (newValue) {
        this._setItemsDisplaySettings({ name: 'showRezerv', value: newValue })
      }
    },
    showTranzit: {
      get () {
        return this._itemsDisplaySettings('showTranzit')
      },
      set (newValue) {
        this._setItemsDisplaySettings({ name: 'showTranzit', value: newValue })
      }
    },
    showPriemka: {
      get () {
        return this._itemsDisplaySettings('showPriemka')
      },
      set (newValue) {
        this._setItemsDisplaySettings({ name: 'showPriemka', value: newValue })
      }
    },
    showRecommendedOnly: {
      get () {
        return this._itemsDisplaySettings('showRecommendedOnly')
      },
      set (newValue) {
        this._setItemsDisplaySettings({ name: 'showRecommendedOnly', value: newValue })
      }
    }
  },
  methods: {
    ...mapActions('catalog', {
      _loadCurrentDocument: 'loadCurrentDocument',
      _setCurrentDocument: 'setCurrentDocument',
      _setItemsDisplaySettings: 'setItemsDisplaySettings',
      _loadItemsTableContent: 'loadItemsTableContent',
      _resetItemsTableQuantity: 'resetItemsTableQuantity',
      _searchItems: 'searchItems',
      _saveDocument: 'saveDocument',
      _resetItemsTableContent: 'resetItemsTableContent',
      _setSearchQuery: 'setSearchQuery'
    }),
    async changeCurrentDocument (currentDocument) {
      if (currentDocument.id) {
        this.$router.push({
          name: `catalog/document`,
          params: { docId: currentDocument.id, docName: currentDocument.name }
        })
        await this._loadCurrentDocument(currentDocument)
        this._loadItemsTableContent()
      } else {
        this.$router.push({
          name: `catalog/newDocument`,
          params: { docName: currentDocument.name }
        })
        this._setCurrentDocument(JSON.parse(JSON.stringify(currentDocument)))
        this._loadItemsTableContent()
      }
    },
    clearSearch () {
      this._loadItemsTableContent()
    },
    showCurrentDocument () {
      this.$refs.catalogDocumentModal.open()
    },
    async saveDocument () {
      this._isSaving = true
      let response = await this._saveDocument()
      if (response.success) {
        this._setCurrentDocument(JSON.parse(JSON.stringify(this._emptyDocuments[this._defaultDocument])))
        this._resetItemsTableContent()
        this.$router.push({
          name: `documents/${response.document.name}`,
          params: { docId: response.document.id }
        })
        this._isSaving = false
      } else {
        this._isSaving = false
        console.log(response.error)
      }
    },
    async searchItems () {
      // if (this.searchQuery.length >= 3) {
      //   await this._searchItems(this.searchQuery)
      // }
      await this._searchItems()
    },
    openOptionsDialog (item) {
      this.$emit('openOptionsDialog', item)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .catalog-toolbar {
    display: flex
    flex-direction row
    justify-content flex-start
    align-items flex-start
    flex-wrap: wrap
    margin-left: 16px
    @media screen and (max-width: 959px) {
      margin-left: 0
    }
    @media screen and (max-width: 372px) {
      justify-content center
      margin-left: 0
    }

    .catalog-view-doc {
      margin-right: 0;
      margin-left: 0;
      border-radius: 0;
      padding-left: 0;
      padding-right: 0;
      width: 280px;
      @media screen and (max-width: 959px) {
        width: 200px;
        font-size 12px;
        right 0;
        left: 0;
        margin-right: 0
        margin-left: 0
      }
    }

    .catalog-save-doc {
      margin-left: 0;
      min-width: 36px;
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
      @media screen and (max-width: 959px) {
        right: 0
      }
    }

    .catalog-select-doc {
      margin-right: 0;
      min-width: 36px;
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
      @media screen and (max-width: 959px) {
        width: 48px
        left: 0
        right: 0
      }
    }

    .catalog-search-field {
      @media screen and (min-width: 800px) {
        max-width 320px
      }
      @media screen and (min-width: 960px) {
        max-width 520px
      }
    }
  }
</style>
